import { render, staticRenderFns } from "./problemStatusList.vue?vue&type=template&id=6b28d4f6&scoped=true&"
import script from "./problemStatusList.vue?vue&type=script&lang=js&"
export * from "./problemStatusList.vue?vue&type=script&lang=js&"
import style0 from "./problemStatusList.vue?vue&type=style&index=0&id=6b28d4f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28d4f6",
  null
  
)

export default component.exports